import type { StyleLayer } from './utils/types'

export const layers_roads_plus_oneway: StyleLayer[] = [
  {
    id: 'oneway-road',
    type: 'line',
    filter: [
      'all',
      ['has', 'oneway'],
      ['match', ['get', 'oneway_bicycle'], ['no', 'yes'], false, true],
      [
        'match',
        ['get', 'road'],
        [
          'motorway',
          'motorway_link',
          'primary',
          'primary_link',
          'trunk_link',
          'trunk',
          'secondary_link',
          'secondary',
        ],
        false,
        true,
      ],
    ],
    minzoom: 11,
    paint: {
      'line-color': [
        'match',
        ['get', 'oneway'],
        ['yes_dual_carriageway'],
        '#f1e9f2',
        ['yes'],
        '#fad329',
        '#000000',
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1, 22, 16],
    },
  },
  {
    id: 'oneway-road-bicycle',
    type: 'line',
    filter: ['has', 'oneway_bicycle'],
    minzoom: 11,
    paint: {
      'line-color': [
        'match',
        ['get', 'oneway_bicycle'],
        ['no'],
        '#54f8b6',
        ['yes'],
        '#fad329',
        'rgba(0, 0, 0, 0.22)',
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1, 22, 16],
    },
  },
  {
    id: 'roads-onewaybikeyes-pattern plus',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'oneway_bicycle'], ['no'], true, false],
      [
        'match',
        ['get', 'road'],
        [
          'motorway',
          'motorway_link',
          'primary',
          'primary_link',
          'trunk_link',
          'trunk',
          'secondary_link',
          'secondary',
        ],
        false,
        true,
      ],
    ],
    minzoom: 13,
    layout: {
      'line-cap': 'square',
      'line-miter-limit': 0,
    },
    paint: {
      'line-opacity': 0.8,
      'line-pattern': 'pattern-oneway-bicycle',
      'line-width': ['interpolate', ['linear'], ['zoom'], 13, 3, 15, 5, 22, 10],
    },
  },
  {
    id: 'roads-oneway-pattern plus',
    type: 'line',
    filter: [
      'all',
      ['has', 'oneway'],
      ['match', ['get', 'oneway'], ['yes', 'implicit_yes'], true, false],
      [
        'match',
        ['get', 'road'],
        [
          'motorway',
          'motorway_link',
          'primary',
          'primary_link',
          'trunk_link',
          'trunk',
          'secondary_link',
          'secondary',
        ],
        false,
        true,
      ],
    ],
    minzoom: 13,
    layout: {
      'line-cap': 'square',
    },
    paint: {
      'line-opacity': 0.7,
      'line-pattern': 'pattern-oneway',
      'line-width': ['interpolate', ['linear'], ['zoom'], 13, 3, 15, 5, 22, 10],
    },
  },
]
